export enum KpiWindowType {
  OpenTurns = 1,
  Days30 = 30,
  Days60 = 60,
  Days90 = 90,
  Months6 = 6,
  Months12 = 12,
}
